import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {SwissAppConfigModels} from '../models/swissappconfig-models';
import {HelperService} from './helper.service';
import {UserAuthenticationService} from './user-authentication.service';
import {tap} from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  private webServiceConfig?: SwissAppConfigModels.WebServiceConfig;

  constructor(private http: HttpClient,
              private userAuthService: UserAuthenticationService,
              private helperService: HelperService
  ) {
      this.helperService.getSwissWebServiceConfig$().pipe(
          takeUntilDestroyed(),
          tap((config) => {
              this.webServiceConfig = config;
          })
      ).subscribe();
  }

  addUserToMessageReceiver(sub: PushSubscription) {
    const body = JSON.stringify(sub);
    const url = this.webServiceConfig!.mesUrl;

    return this.http.post<PushSubscription>(url + '/NeuerNachrichtenEmpfaenger', body, {
      headers: new HttpHeaders({'Content-Type': 'application/json', Authorization: this.helperService.getSwissAuthorization(this.userAuthService.currentUserInfo),}),
    }).subscribe({
        next: (res) => console.log(res),
        error: (err) => console.log(err),
      });
  }
}
